import { render, staticRenderFns } from "./IntroductionForm.vue?vue&type=template&id=a08d431a&scoped=true&"
import script from "./IntroductionForm.vue?vue&type=script&lang=js&"
export * from "./IntroductionForm.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionForm.vue?vue&type=style&index=0&id=a08d431a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08d431a",
  null
  
)

export default component.exports